class ProductReviews extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.fetchData()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.listeners.add(this.els.write.element, 'click', this.handleTrigger)
  }

  fetchData () {
    const okendoScripts = document.querySelectorAll(
      '[data-oke-metafield-data]',
    )

    const reviewScript = [...okendoScripts].find((script) =>
      script.textContent.includes('productAttributes'),
    )

    if (!reviewScript) return this.handleNoReviews()

    const data = JSON.parse(reviewScript.textContent)
    const featuredReview = data.reviews?.find((review) => review.rating >= 4)

    if (!featuredReview) return this.handleNoReviews()

    this.els.default.element.setAttribute('aria-hidden', 'true')
    this.els.okendo.element.setAttribute('aria-hidden', 'false')

    this.els.review.element.innerText = `"${featuredReview.body}"`
    this.els.author.element.innerText = featuredReview.reviewer.displayName
  }

  handleNoReviews () {
    if (!this.hasAttribute('data-hide-if-empty')) return
    if (this.els.fallback?.exists) return
    if (window.Shopify?.designMode) return

    this.setAttribute('hidden', '')
  }

  handleTrigger () {
    const writeReview = document.querySelector('.oke-w-writeReview')
    writeReview.click()
  }
}

if (!customElements.get('product-reviews')) {
  customElements.define('product-reviews', ProductReviews)
}
